export default "__VITE_ASSET__Dioe1NIX__"